//Single source for the "we could not load this" copy. Both the modal raised by
//useStudyWithUserCheck and the inline ContentUnavailableView behind it show this
//text, so it must not drift between them. DEV-397.
//
//Deliberately does not assert that the object was deleted: the REST layer
//collapses every failure into a bare string (see use-rest-api.hook.ts), so a
//timeout or a 500 arrives here looking exactly like a 404.
export const getContentUnavailableMessage = (noun: string) =>
    `This ${noun} could not be loaded. It may have been withdrawn or removed from Vivli. ` +
    `Please try again, or contact the Vivli team if the problem continues.`;

export const ContentUnavailableGenericNoun = 'content';
